import { useCallback, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";

const OPEN_KEY = "chatbotOpen";
const FULL_KEY = "chatbotFull";
const CONVERSATION_KEY = "chatbotId";

export function useChatbotUrlState() {
	const history = useHistory();
	const location = useLocation();

	const params = useMemo(
		() => new URLSearchParams(location.search),
		[location.search],
	);

	const updateParams = useCallback(
		(updates: Record<string, string | null>) => {
			const next = new URLSearchParams(location.search);
			for (const [key, value] of Object.entries(updates)) {
				if (value === null) {
					next.delete(key);
				} else {
					next.set(key, value);
				}
			}
			history.replace({ search: next.toString() });
		},
		[history, location.search],
	);

	const setIsOpen = useCallback(
		(open: boolean) => {
			// chatbotId zostaje po zamknięciu → ponowne otwarcie kontynuuje rozmowę
			updateParams(
				open ? { [OPEN_KEY]: "1" } : { [OPEN_KEY]: null, [FULL_KEY]: null },
			);
		},
		[updateParams],
	);

	const setIsFullWidth = useCallback(
		(full: boolean) => {
			updateParams({ [FULL_KEY]: full ? "1" : null });
		},
		[updateParams],
	);

	const setActiveConversationId = useCallback(
		(id: string | null) => {
			updateParams({ [CONVERSATION_KEY]: id });
		},
		[updateParams],
	);

	return {
		isOpen: params.get(OPEN_KEY) === "1",
		setIsOpen,
		isFullWidth: params.get(FULL_KEY) === "1",
		setIsFullWidth,
		activeConversationId: params.get(CONVERSATION_KEY),
		setActiveConversationId,
	};
}
